export default "__VITE_ASSET__DwEHWKCs__"